import { render, staticRenderFns } from "./compensationType.pug?vue&type=template&id=b3b803a8&lang=pug&external"
import script from "./compensationType.js?vue&type=script&lang=js&external"
export * from "./compensationType.js?vue&type=script&lang=js&external"
import style0 from "./compensationType.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3b803a8')) {
      api.createRecord('b3b803a8', component.options)
    } else {
      api.reload('b3b803a8', component.options)
    }
    module.hot.accept("./compensationType.pug?vue&type=template&id=b3b803a8&lang=pug&external", function () {
      api.rerender('b3b803a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Claim/views/compensationType/index.vue"
export default component.exports